import React from "react";
import { Z_INDEX } from "../../core/utils/zIndexScale";
import { surfaces } from "../../design-system/tokens";

export const AddButton = ({
  onClick,
  small = false,
  className = "",
  zIndex = Z_INDEX.ADD_BUTTON_BASE,
  backgroundColor = surfaces.secondary,
  tutorialTargetId = null,
  style: styleOverrides = {},
  ...buttonProps
}) => {
  const sizeClasses = small ? "w-5 h-5 text-xs" : "w-8 h-8 text-lg";

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      className={`flex items-center justify-center rounded-full transition-all duration-150 !text-white !border-2 !border-white ${sizeClasses} ${className}`}
      style={{
        lineHeight: 1,
        position: "relative",
        zIndex,
        backgroundColor,
        ...styleOverrides,
      }}
      data-tutorial-id={tutorialTargetId || undefined}
      {...buttonProps}
    >
      +
    </button>
  );
};

export default AddButton;
